import { h, render, Component } from 'preact';
import { Text} from 'preact-i18n';
import { useState, useRef, useEffect } from 'preact/hooks';
import './aemodal.scss';

export const Modal = props => {
  const [showModal, setshowModal] = useState(false);
  const showModalRef = useRef(showModal);
  let registeredEvent = false;
  registerEvents();
  
  useEffect(
    () => { showModalRef.current = showModal }, [showModal]
  )

  function registerEvents() {
    if(!registeredEvent) {
      registeredEvent = true;
      document.addEventListener("click", () => {
        if(showModalRef.current) {
          setshowModal(false);
        }
      });
      document.addEventListener("keydown", (e) => {
        if(e.key === "Escape") {
          if(showModalRef.current) {
            setshowModal(false);
          }
        }
      });
    }
  }

  return (
    // icon is currently hard-coded to 18x18 px
    <span>
      <span onClick={(evt)=> evt.stopPropagation()}>
        <span onClick={() => setshowModal(true)}>  
          <svg className="" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#999"><path d="M0 0h24v24H0V0z" fill="none"/>
            <path d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>
          </svg>
        </span>
      </span>
      {showModal ?
        <div class="modal">
          <div class="modal-content">
            <div className="modal-header">
              <div>
                {props.headerKey ? (
                  <Text id={props.headerKey}></Text>
                ):("")}
              </div>
              <span className="closeIcon">
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="var(--black)">
                  <path d="M0 0h24v24H0V0z" fill="none"/>
                  <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"/>
                </svg>
              </span>
            </div>
            <div className="modal-info">
              {props.textKey ? ( // Prioritize text key over raw text
                <Text id={props.textKey}></Text>
              ) : props.toolTipText ? (
                props.toolTipText )
              :("")}
            </div>
          </div>
      </div>
      : ("")
      }
    </span>
  )
}
